import React, { FC } from 'react';
import {
  DragDropContext as DragDropContextBase,
  Droppable as DroppableBase,
  OnDragEndResponder,
} from 'react-beautiful-dnd';
import { List } from '@mui/material';
import { DraggableListItem } from './DraggableListItem';
import { TagType } from '../../types/types';

const DragDropContext = DragDropContextBase as React.ComponentType<any>;
const Droppable = DroppableBase as React.ComponentType<any>;
export type Props = {
  items: any[];
  selectedTags: string[];
  dropdownData: { value: any[]; loaded: boolean };
  onDragEnd: OnDragEndResponder;
  onRemoveRow: (id: string) => void;
  handleSetRow: (
    rowId: string,
    tagId: string,
    gatewayId: string,
    parentType: string,
    tag: TagType | null
  ) => void;
  handleMobileListWidth: (value: string) => void;
  paddingLeft?: string;
  isLiftStation?: boolean;
};

export const DraggableList: FC<Props> = React.memo(
  ({
    items,
    onDragEnd,
    onRemoveRow,
    dropdownData,
    handleSetRow,
    handleMobileListWidth,
    selectedTags,
    paddingLeft,
    isLiftStation,
  }) => (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {(provided: any) => (
          <List
            sx={{ overflow: 'hidden', pt: '8px!important', pb: '8px' }}
            ref={provided.innerRef}
            data-testid="droppable-container"
            {...provided.droppableProps}
          >
            {items.map((item: any, index: number) => (
              <DraggableListItem
                item={item}
                rows={items}
                selectedTags={selectedTags}
                index={index}
                key={item.id}
                onRemoveRow={onRemoveRow}
                dropdownData={dropdownData}
                handleSetRow={handleSetRow}
                handleMobileListWidth={handleMobileListWidth}
                data-testid={`draggable-item-${item.id}`}
                paddingLeft={paddingLeft}
                isLiftStation={isLiftStation}
              />
            ))}
            <>{provided.placeholder}</>
          </List>
        )}
      </Droppable>
    </DragDropContext>
  )
);
